import { Box, ColorOptions, convertHexToRGBA, Spacer, Text } from '@jfs/ui-new'
import { SvgImage } from '../../comps/SvgImage'
import { getString } from '../../util/languageStrings'
import { Colors } from '../../util/util'

export const Note = (selectedAppLanguage: any) => {
  return (
    <Box flexDirection={'row'} align={'center'} mt={2}>
      <SvgImage imageName="InfoIcon" />
      <Spacer size={4} direction={'horizontal'} />
      <Text
        title={getString(selectedAppLanguage, 'passwordNote')}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
        letterSpacing={-0.07}
      />
    </Box>
  )
}
